
export class RadiusSelector extends HTMLElement
{
    constructor ()
    {
        super();
    }

    init(map)
    {
        this.map = map;
        this.#initRadiusSelector();
        this.#initEventHandlers();
    }

    getRadius()
    {
        // always returns in kilometers
        const radiusSelector = this.querySelector('#radius-selector-radius');
        const radiusUomSelector = this.querySelector('#radius-selector-uom');
        let km = radiusSelector.value;
        if (radiusUomSelector.value == 'mi') {
            km *= 1.609;
        }
        return km;
    }

    #initEventHandlers()
    {
        const radiusSelector = this.querySelector('#radius-selector-radius');
        const radiusUomSelector = this.querySelector('#radius-selector-uom');

        radiusSelector.addEventListener('change', this.onRadiusUomChangeEvent);
        radiusUomSelector.addEventListener('change', this.onRadiusUomChangeEvent);

    }

    #initRadiusSelector()
    {
        this.#createRadiusSelector();
        this.map.controls[google.maps.ControlPosition.TOP_RIGHT].push(this);
    }

    #createRadiusSelector()
    {
        this.setAttribute('id', 'radius-selector-container');
        this.classList.add('form-inline');
        const title = this.appendChild(document.createElement('h4'));
        title.textContent = 'Select the radius to search for Vetology Facilities';
        const inputGroup = this.appendChild(document.createElement('div'));
        inputGroup.classList.add('form-group');
        const label = inputGroup.appendChild(document.createElement('label'));
        label.setAttribute('for', 'radius-selector');
        label.textContent = 'Radius';
        const selector = inputGroup.appendChild(document.createElement('select'));
        selector.classList.add('form-control');
        selector.setAttribute('id', 'radius-selector-radius');
        selector.appendChild(this.#createSelectorOption('10', '10'));
        selector.appendChild(this.#createSelectorOption('25', '25'));
        selector.appendChild(this.#createSelectorOption('50', '50'));
        selector.appendChild(this.#createSelectorOption('100', '100'));
        selector.appendChild(this.#createSelectorOption('250', '250'));

        const uomSelector = this.appendChild(document.createElement('select'));
        uomSelector.classList.add('form-control');
        uomSelector.setAttribute('id', 'radius-selector-uom');
        uomSelector.appendChild(this.#createSelectorOption('km', 'km'));
        uomSelector.appendChild(this.#createSelectorOption('mi', 'mi'));

    }

    #createSelectorOption(name, value)
    {
        const option = document.createElement('option');
        option.value = value;
        option.textContent = name;
        return option;
    }

    onRadiusUomChangeEvent(event)
    {
        const evt = new CustomEvent('geomap-radius-selector-change-event', {
            detail: {
                originalEvent: event
            }
        });
        document.dispatchEvent(evt);
    }

}

customElements.define('geomap-radius-selector', RadiusSelector);